// Add your custom JS here.


// Social Sharing Copy URL Button
document.addEventListener('DOMContentLoaded', function () {

	if(document.getElementById("dropdownShareButton")) initBtnCopyUrl();

    // Prise du focus au clic de la recherche
    document.getElementById('searchform-button').addEventListener("click", () => {
        document.getElementById("s-1").focus();
    })

    // empêche le menu de se refermer au clic
    document.querySelectorAll('.dropdown-menu').forEach(function(menu) {
        menu.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });

})

/**
 * Create a copy feature for all elements with class name 'btn-copy-url'
 *
 * @todo create a param to change class name selector
 */
function initBtnCopyUrl() {

	let hideFeature = false;
	if(!navigator.clipboard){
		console.error("Clipboard not available for this browser. Copy URL feature aborted.");
		hideFeature = true;
	}

	if(!window.isSecureContext) {
		console.error("You're not in a secure context. Clipboard API is disabled. Copy URL feature aborted.");
		hideFeature = true;
	}

	const btnCopyCollection = document.getElementsByClassName('btn-copy-url');

	if(hideFeature) {
		for(let btnCopy of btnCopyCollection) {
			let parentElement = btnCopy.closest('li');
			parentElement.style.display = 'none';
		}
		return;
	}

	for(let btnCopy of btnCopyCollection) {
		btnCopy.addEventListener('click', function (event) {
			let currentElement = event.currentTarget;
			let currentURL = currentElement.getAttribute('data-clipboard') || window.location.href;
			// TODO : use wp-i18n methods here if need multilingual
			let copiedMsg = currentElement.getAttribute('data-clipboard-msg') || 'Lien copié';

			// copy in navigator.clipboard (not available with IE)
			navigator.clipboard.writeText(currentURL);

			currentElement.firstElementChild.textContent =  copiedMsg;
			currentElement.classList.add( 'copied' );

			let timer = setInterval( function(){
				currentElement.classList.remove( 'copied' );
				clearInterval(timer);
			}, 1200 );
		})
	}
    
}